import { TICKETING_FORM_KEY } from './ticketingFormKeys';

/**
 * Primary free-text submitted with the ticket (original request wording).
 * @returns {string|null}
 */
export function getTicketOriginalDescription(payload, formKey) {
  const p = payload && typeof payload === 'object' && !Array.isArray(payload) ? payload : {};

  switch (formKey) {
    case TICKETING_FORM_KEY.GENERAL:
    case TICKETING_FORM_KEY.GENERAL_IT:
      return trimOrNull(p.description);
    case TICKETING_FORM_KEY.HR_EMPLOYEE_IT:
    case TICKETING_FORM_KEY.HR_EMPLOYEE_EDIT_IT:
    case TICKETING_FORM_KEY.HR_EMPLOYEE_DELETE_IT:
    case TICKETING_FORM_KEY.WAREHOUSE_ACCESS:
      return trimOrNull(p.comments);
    default: {
      const desc = trimOrNull(p.description);
      if (desc) return desc;
      return trimOrNull(p.comments);
    }
  }
}

function trimOrNull(value) {
  if (value == null) return null;
  const s = String(value).trim();
  return s || null;
}
